var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"table",attrs:{"service":_vm.ProductService,"entity":_vm.entity,"filters":_vm.filters,"columns":_vm.columns,"disablePermissionChecks":true,"operations":"add,edit,refresh,delete"},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.name)+"\n    ")]}},{key:"product_type",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.product_type)+"\n    ")]}},{key:"payment_type",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.payment_type)+"\n    ")]}},{key:"price",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(_vm._f("toCurrency")(row.price))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }